import React, { useEffect, useState } from 'react'
import { useStateContext } from '../contexts/ContextProvider'
import CartItem from '../components/CartItem';
import useIsMobileDevice from '../hooks/useIsMobileDevice';
import { getActualPrice } from '../lib/apiService';
import { useNavigate } from 'react-router-dom';

const Cart = () => {
  const { cartItems, setCartItems, selectedItemsInCart, setSelectedItemsInCart, setTotalPrice } = useStateContext();
  const [selectAll, setSelectAll] = useState(false);
  const [price, setPrice] = useState(0);
  const isMobileDevice = useIsMobileDevice();
  const navigate = useNavigate();

  useEffect(() => {
    setPrice(
      cartItems.products.reduce((prev, cur) => prev + cur.price * cur.quantity, 0)
      + cartItems.documents.reduce((prev, cur) => prev + cur.price * cur.quantity, 0)
    );
  }, [cartItems]);


  const handleDeleteSelectedItems = () => {
    if (selectAll) {
      setSelectedItemsInCart([]);
      setCartItems({
        ...cartItems,
        documents: [],
        products: []
      });
    } else {
      setSelectedItemsInCart([]);
      setCartItems({
        ...cartItems,
        documents: cartItems.documents.filter(item => !selectedItemsInCart.includes(item)),
        products: cartItems.products.filter(item => !selectedItemsInCart.includes(item)),
      });
    }
  };

  const handleCheckout = async () => {
    if (selectedItemsInCart.length === 0) {
      if (!selectAll) {
        alert('Please select at least one item to checkout.');
        return;
      } else {
        setSelectedItemsInCart([...cartItems.documents, ...cartItems.products]);
      }
    }
    // Get the actual price from the server
    setTotalPrice(await getActualPrice(selectedItemsInCart || cartItems));

    // Redirect to the checkout page
    navigate('/checkout');
  };

  const renderPayWith = () => (
    <div className='mt-2 bg-slate-50 shadow-md rounded-md p-4 pb-6'>
      <h2 className='text-xl font-bold text-left pb-4'>Pay with</h2>
      <div className='flex flex-row items-center gap-1'>
        <img  src={require('../assets/images/cib.png')} alt="CIB" className="w-10 h-12 object-cover rounded border border-gray-300" />
        <img src={require('../assets/images/edahabia.png')} alt="EDAHABIA" className="w-10 h-12 object-cover rounded border border-gray-300" />
      </div>
    </div>
  );

  return (
    <div className='w-full bg-gray-200 pb-10'>
      <div className='relative w-11/12 h-screen mx-auto pt-10 flex flex-row gap-2'>
        {/* Cart */}
        <section className={`${isMobileDevice ? 'w-full' : 'w-8/12'}`}>
          <div className={`flex ${isMobileDevice ? 'flex-col items-start gap-2' : 'flex-row justify-between'} p-4 bg-slate-50 mb-2 shadow-md rounded-md`}>
            <h1 className='text-2xl font-bold text-left'>Shopping Cart</h1>
            {(cartItems.documents.length > 0 || cartItems.products.length > 0) && (
              <div className='flex flex-row items-center gap-2 text-md'>
                <div
                  className='flex flex-row items-center gap-2'
                  title={selectAll ? 'Unselect all' : 'Select all'}
                >
                  <input
                    type="checkbox"
                    name='selectAll'
                    id='selectAll'
                    className='w-4 h-4'
                    checked={selectAll}
                    onChange={() => setSelectAll(!selectAll)}
                  />
                  <label htmlFor="selectAll" className=''>Select all</label>
                </div>
                <div
                  className='border-l border-gray-300 h-6 px-2 hover:cursor-pointer hover:text-blue-400'
                  title='Delete selected items from cart'
                  onClick={handleDeleteSelectedItems}
                >
                  <span className='underline underline-offset-1'>Delete selected items</span>
                </div>
              </div>
            )}
          </div>
          <div className='bg-slate-50 shadow-md rounded-md p-4 min-h-[115px] overflow-y-auto'>
            {cartItems.documents.length === 0 && cartItems.products.length === 0 && (
              <div className='flex flex-col items-center justify-center h-full'>
                <h1 className='text-2xl font-medium text-center mb-2'>Your cart is empty</h1>
                <p className='text-center text-gray-500'>Looks like you haven't added anything to your cart yet.</p>
              </div>
            )}
            {cartItems.documents.length > 0 && (
              <section>
                <h1 className="text-xl font-bold text-left py-4">
                  You want to print :
                </h1>
                {cartItems.documents.map((doc, index) => (
                  <CartItem
                    key={index}
                    document={doc}
                    selectAll={selectAll}
                    selectedItems={selectedItemsInCart}
                    setSelectedItems={setSelectedItemsInCart}
                  />
                ))}
              </section>
            )}
            {cartItems.products.length > 0 && (
              <section className="">
                <h1 className="text-xl font-bold text-left py-4">
                  You want to buy :
                </h1>
                {cartItems.products.map((product, index) => (
                  <CartItem
                    key={index}
                    product={product}
                    selectAll={selectAll}
                    selectedItems={selectedItemsInCart}
                    setSelectedItems={setSelectedItemsInCart}
                  />
                ))}
              </section>
            )}
          </div>
        </section>

        {/* Summary */}
        {isMobileDevice ? (
          <section className='absolute bottom-0 left-0 w-full'>
            <div className='flex flex-row items-center justify-between bg-slate-50 shadow-md rounded-md p-4'>
              <p className='flex-1/2'>
                DA {price}
              </p>
              <button
                className='flex-1/2 bg-blue-500 hover:bg-blue-400 text-white rounded-2xl px-4 py-2'
                onClick={() => handleCheckout()}
              >
                Checkout
              </button>
            </div>
            {renderPayWith()}
            
          </section>
        ) : (
          <section className='sticky top-20 w-4/12 max-h-[200px]'>
            <div className='bg-slate-50 shadow-md rounded-md p-4'>
              <h1 className="text-2xl font-bold text-left pb-4">
                Summary
              </h1>
              <div className='flex flex-row justify-between gap-2'>
                <h3 className='text-lg font-bold'>Total</h3>
                <p>DA {price}</p>
              </div>
              <button
                className='bg-blue-500 hover:bg-blue-400 text-white rounded-xl p-2 w-full mt-6'
                onClick={() => handleCheckout()}
              >
                Checkout
              </button>
            </div>
            {renderPayWith()}
          </section>
        )}
      </div>
      
    </div>
  )
}

export default Cart